import React from 'react'


import Home from './Home'

class FixedFooter extends React.Component {
 

  render () {
    return (
        <div className="fixedFooter">
<div className="footerInfo">Copyright &copy; 2020 Soul Medicine. All rights reserved.</div>
<div className="footerInfo">Website design and build by PHEARNOC Digital</div>
        </div>

    )
  }
}


export default FixedFooter